<p-autoComplete [(ngModel)]="supplier" (ngModelChange)="supplierChange.emit($event)"
                name="supplier" [disabled]="mode !== DetailMode.EDITION"
                class="supplier-autocomplete acted-highlight-req metadata-field" [required]="required"
                [suggestions]="allSuppliers" optionLabel="code" (completeMethod)="getSupplierSuggestions($event)"
                [multiple]="false" [forceSelection]="true"
                [dropdown]="false" dropdownMode="current" i18n-placeholder="@@common-none" placeholder="(none)"
                appendTo="body" [tabindex]="tabindex">
  <!-- define custom template for filter options -->
  <ng-template pTemplate="item"  let-supplier>
   {{ supplier.code }} ({{ supplier.name }})
  </ng-template>
</p-autoComplete>
<!-- Put back [minQueryLength]="2" once this bug is fixed: https://github.com/primefaces/primeng/issues/19218           -->
